import React, { Component } from 'react';
// import ReactDOM from "react-dom";
import { connect } from 'react-redux';
// import * as Contracts from '../../Store/Contracts';
import * as Transfer from './Saga/Transfer';
import Button from '@material-ui/core/Button';
import PersonIcon from '@material-ui/icons/Person';
import { Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import KyDetails from '../KyDetail/Index';
import * as KyDetail from '../KyDetail/Saga/KyDetail';
// import '../../Css/Grid.css';
var moment = require("moment-timezone");

const ReactDataGrid = require('react-data-grid');
interface Props {
  // get_banks: any,
  rent_transfer_accounts: any,
  shops: any,
  change_rent_transfer_accounts: any,
  change_searchky: any,
}



interface State {
  columns: any
  refresh: boolean
  list: any,
  kytoggle: boolean
  // state types
}


const DateFormatter = (payload: any) => {
  if (payload.value) {
    // return moment(payload.value).date();
    // return moment(payload.value).utcOffset(payload.value).tz("Asia/Tokyo").format('YYYY/MM/DD')
    return moment(payload.value).format("YYYY/MM/DD");
  } else {
    return "";
  }
};
const StatusFormatter = (payload: any) => {
  if (payload.value === 10) {
    return "成功";
  } else {
    return "失敗";
  }
};


const depositkindFormatter = (payload: any) => {
  if (payload.value === 1) {
    return "普通";
  } else {
    return "";
  }
};

const siteFormatter = (payload: any) => {


  if (payload.value === 1) {
    return <span style={{ color: "blue", fontWeight: "bold" }}>へやのしおり</span>;
  } else if (payload.value === 2) {
    return <span style={{ color: "red", fontWeight: "bold" }}>マイページ</span>;
  } else if (payload.value === 3) {
    return <span style={{ color: "green", fontWeight: "bold" }}>グローバルパーキング</span>;
  } else if (payload.value === 4) {
    return <span style={{ color: "#FFA500", fontWeight: "bold" }}>スマート切替</span>;
  } else {
    return "";
  }
};

const kakumeistatusFormatter = (payload: any) => {
  if (payload.value === 1) {
    return <span style={{ color: "blue", fontWeight: "bold" }}>登録済み</span>;
  } else if (payload.value === 2) {
    return <span style={{ color: "red", fontWeight: "bold" }}>登録不可</span>;
  } else {
    return "";
  }
};
const tatemonoFormatter = (payload: any) => {
  if (payload.row.rent_contract_id > 0) {
    return payload.row.tatemono_name;

  } else {
    return payload.row.free_tatemono_name;
  }
};

const roomFormatter = (payload: any) => {
  if (payload.row.rent_contract_id > 0) {
    return payload.row.room_name;

  } else {
    return payload.row.free_room_name;
  }
};

const nameFormatter = (payload: any) => {
  if (payload.row.rent_contract_id > 0) {
    return payload.row.rent_customer_name;

  } else {
    return payload.row.free_name;
  }
};

const sectionFormatter = (payload: any) => {
  if (payload.row.rent_contract_id > 0) {
    return payload.row.section_name;

  } else {
    return payload.row.free_kouza_reason === 1 ? "口座変更" : payload.row.free_kouza_reason === 2 ? "浄水器引落" : payload.row.free_kouza_reason === 3 ? "新規受託" : "";
  }
};


// const SelectFormatter =(payload:any) => {
//   console.log(payload)
//   if(payload.row.receipt_at && payload.row.payment_at){
//     // return moment(payload.value).format("YYYY/MM/DD");
//     return <div>　</div>
//   }else{
//     return <div  style={{background:"#CCC"}}>　</div>;
//   }
//   };

const conditionFormatter = (payload: any) => {
  if (payload.value) {
    return moment(payload.value).format("YYYY/MM/DD");
  } else {
    return "";
  }
};

const ContractFormatter = (payload: any) => {
  console.log(payload)
  if (payload.row.contract_cancel === 1) {
    return "キャンセル " + payload.row.contract_remarks;
  } else if (payload.row.contract_amount && payload.row.works === 1) {
    return payload.row.contract_amount + " " + payload.row.contract_remarks;
  } else if (payload.row.rent_m_etc_id === 3) {
    return "無し " + payload.row.contract_remarks;
  } else if (payload.row.rent_m_etc_id === 4 && payload.row.works === 1) {
    return "WEB " + payload.row.contract_remarks;
  } else if (payload.row.works === 2) {
    return "他社 " + payload.row.contract_remarks;
  } else if (payload.row.works === 3) {
    return "家主 " + payload.row.contract_remarks;
  } else {
    return "";
  }
};


const defaultColumnProperties = {
  sortable: true,
  // width: 120
};




/**
 *会計連動グリッド
 *
 * @class AccountingGridComponent
 * @extends {Component<Props, State>}
 */
class AccountingGridComponent extends Component<Props, State> {
  constructor(props: Readonly<Props>) {
    super(props);


    this.state = {
      refresh: false,
      columns: [
        // { key: 'id', name: 'ID', width: 60, resizable: true },
        {
          key: 'selected', name: '賃革取込', width: 60, resizable: true
        },
        { key: 'kakumei_status', name: '結果', width: 60, resizable: true, formatter: kakumeistatusFormatter },
        { key: 'result_code', name: 'ステータス', width: 60, resizable: true, formatter: StatusFormatter },
        { key: 'site', name: 'サイト', width: 60, resizable: true, formatter: siteFormatter },
  
        { key: 'created_at', name: '登録日', width: 100, resizable: true, formatter: DateFormatter },
        { key: 'tatemono_name', name: '建物名', width: 150, resizable: true, formatter: tatemonoFormatter },
        { key: 'room_name', name: '部屋名', width: 60, resizable: true, formatter: roomFormatter },
        { key: 'rent_customer_name', name: '顧客名', width: 100, resizable: true, formatter: nameFormatter },
        { key: 'contract_date', name: '契約日', width: 130, resizable: true, formatter: DateFormatter },
        { key: 'section_name', name: '店舗', width: 100, resizable: true, formatter: sectionFormatter },
        { key: 'bank_code', name: '銀行番号', width: 100, branch_id: true },
        { key: 'bank_name', name: '銀行名', width: 100, branch_id: true },
        { key: 'shop_code', name: '支店番号', width: 100, branch_id: true },
        { key: 'shop_name', name: '支店名', width: 80, resizable: true },
        // { key: 'name', name: '振込名義', width: 150,resizable: true },
        // { key: 'deposit_amount', name: '振込金額', width: 150,resizable: true },
        // { key: 'remarks', name: '備考', width: 100,resizable: true },
        { key: 'deposit_kind', name: '口座種別', width: 60, resizable: true, formatter: depositkindFormatter },
        { key: 'account_number', name: '口座番号', width: 100, resizable: true },
        { key: 'account_name_katakana', name: '口座名義', width: 100, resizable: true },
        { key: 'deleted', name: '消込', width: 60, resizable: true },
        { key: 'deleted_at', name: '消込日', width: 100, resizable: true },
        { key: 'kakumei_updated_at', name: '革命登録日', width: 100, resizable: true },
        { key: 'billing_start_month', name: '引き落とし開始月', width: 100, resizable: true },
        // { key: 'bk_no', name: '消込', width: 60, resizable: true },

        // {
        //   key: 'select', name: '選択', width: 60, resizable: true,
        //   //   formatter: SelectFormatter   
        //   //   , editable:  function (rowData:any) {
        //   //     return (rowData.receipt_at && rowData.payment_at) ? true : false;
        //   // }, 
        // },
        // { key: 'condition', name: '状況', width: 80, resizable: true },
        // { key: 'application_at', name: '申込日', width: 90, resizable: true, formatter: DateFormatter },
        // { key: 'nyuukyosha_name', name: '入居者名', width: 80, },
        // { key: 'contractor', name: '契約者名', width: 80, resizable: true },
        // { key: 'account_number', name: '口座番号', width: 80, resizable: true },


        // { key: 'account_name_katakana', name: '口座名義', width: 150, resizable: true },
        // { key: 'amount', name: '金額', width: 80, resizable: true },

        // { key: 'pay_way', name: '支払方法', width: 80, resizable: true },
        // // { key: 'tatemonoAddress1', name: '建物住所', width: 100,resizable: true },
        // { key: 'tatemono_name', name: '建物名', width: 100, resizable: true },
        // { key: 'room_name', name: '部屋名', width: 60, resizable: true },
        // { key: 'start_at', name: '始期日', width: 90, resizable: true, formatter: DateFormatter },
        // // { key: 'end_at', name: '終了日', width: 90, resizable: true, formatter: DateFormatter },
        // { key: 'receipt_at', name: '領収日', width: 90, resizable: true, formatter: DateFormatter },
        // // { key: 'payment_at', name: '入金日',width: 80, resizable: true, formatter: DateFormatter},
        // { key: 'search', name: '結付', width: 60, resizable: true },
        // { key: 'rent_contract_name1', name: '契約者名', width: 80, resizable: true },
        // { key: 'rent_contract_tatemono_name', name: '建物名', width: 100, resizable: true },
        // { key: 'rent_contract_room_name', name: '部屋名', width: 60, resizable: true },

        // { key: 'contract_amount', name: '請求金額', width: 120, resizable: true, formatter: ContractFormatter },

        // { key: 'delete', name: '消込', width: 60, resizable: true },
        // { key: 'contract_money', name: '契約金',width: 60, resizable: true },

        // { key: 'accounting_output_at', name: '出力日',width: 100, resizable: true },

      ].map(c => ({ ...c, ...defaultColumnProperties })),

      list: this.props.rent_transfer_accounts,
      kytoggle: false,



    };

    this.sortRows = this.sortRows.bind(this);
    this.SectionFormatter = this.SectionFormatter.bind(this);
    this.getCellActions = this.getCellActions.bind(this);
    this.getRowCount = this.getRowCount.bind(this);
    // this.onGridRowsUpdated = this.onGridRowsUpdated.bind(this);
    this.onRowClick = this.onRowClick.bind(this);
    this.kytoggle = this.kytoggle.bind(this);
    this.onKyopen = this.onKyopen.bind(this);
  }

  onKyopen = (bk_no: number, hy_no: string, ky_no: number) => {

    this.props.change_searchky({ bk_no, hy_no, ky_no })

    this.kytoggle()

  }
  kytoggle() {
    this.setState({ kytoggle: !this.state.kytoggle })

    // this.props.get_rent_contract_accounting(this.props.kyousais);
  }

  // onGridRowsUpdated = ({ fromRow, toRow, updated }: any) => {


  //   let kyousais = this.props.rent_transfer_accounts.slice();
  //   // for (let i = fromRow; i <= toRow; i++) {
  //   //   kyousais[i] = { ...kyousais[i], ...updated };
  //   // }


  //   this.props.change_kyousais(kyousais)

  // };

  SectionFormatter = (payload: any) => {

    const result = this.props.shops.filter((x: any) => x.tenpoNo === payload.value);

    return result[0].tenpoName;

  };


  componentWillMount() {

    // this.props.get_banks({output:true,name:"",date1:"",date2:""})


  }
  getSelectedCell(event: any) {
    alert()
  }

  // onRowClick = (rowIdx: any, row: any) => {
  onRowClick = (rowIdx: any) => {
    // console.log(rowIdx)
    // this.props.kyousais[rowIdx.rowIdx].condition = 1
    // this.props.kyousais.concat([])
    // row.condition = 1
    // this.setState({
    //   refresh: true
    // });
    // for (let i = fromRow; i <= toRow; i++) {
    //   kyousais[i] = { ...kyousais[i], ...updated };
    // }
    // kyousais[rowIdx].condition = 1
    // let kyousais = this.props.kyousais
    // this.props.change_kyousais(kyousais)
  }
  // componentDidUpdate() {
  //   if (this.props.grid_update === true) {
  //     this.setState({
  //       refresh: true
  //     });
  //     // this.props.change_grid_update(false)
  //   }
  //   // alert("update")
  // }
  // this.props.get_banks({output:true,name:"",date1:"",date2:""})


  // rowGetter = (i:number) => {
  //     return this.props.rent_contracts_list[i];
  //   };

  onRowsSelected = (rows: any) => {
    console.log(rows)
    rows.forEach(function (r: any) {
      r.row.selected = true;
    });
    alert()
    this.forceUpdate();

  };

  onRowsDeselected = (rows: any) => {

    rows.forEach(function (r: any) {
      r.row.selected = false;
    });
    this.forceUpdate();
  };

  sortRows = (initialRows: any, sortColumn: any, sortDirection: any) => {


    const comparer = (a: any, b: any) => {
      if (sortDirection === "ASC") {

        return a[sortColumn] > b[sortColumn] ? 1 : -1;
      } else if (sortDirection === "DESC") {
        return a[sortColumn] < b[sortColumn] ? 1 : -1;
      } else {
        return 1;
      }

    };
    this.setState({ refresh: !this.state.refresh })
    return sortDirection === "NONE" ? initialRows : this.props.rent_transfer_accounts.sort(comparer);
  };




  getCellActions(column: any, row: any) {

    if (column.key === "selected" && row.result_code === 10 && row.bk_no > 0) {
      return [{
        icon: <div className="float-right" style={{ textAlign: "center", paddingTop: "5px", paddingRight: "-5px", width: "100px", height: "100px", color: "green" }}>{row.selected === 1 ? <i className="fas fa-check" style={{ marginLeft: "20px" }}></i> : ""}</div>,
        callback: () => {
          // row.select = row.select === 1 ? 0 : 1;

          let w = this.props.rent_transfer_accounts.map((q: any) => {
            if (q.id === row.id) return { ...q, selected: row.selected === 1 ? 0 : 1 };
            return q;
          })
          this.props.change_rent_transfer_accounts(w)
        }
      }]

    } else if (column.key === "selected") {
      return [{
        icon: <div className="float-right" style={{ textAlign: "right", paddingRight: "2px", width: "100px", height: "40px", color: "#000000", background: "#CCC" }}> </div>,
        callback: () => {

          //   let estimateMonies2 = this.props.estimateMonies2

          //   if(estimateMonies2.filter(a=>a.rentMAccountId===row.rentMAccountId)[0].taxAmount>0){
          //     estimateMonies2.filter(a=>a.rentMAccountId===row.rentMAccountId)[0].taxAmount= 0
          //     estimateMonies2.filter(a=>a.rentMAccountId===row.rentMAccountId)[0].tax= false
          // }else{
          //     estimateMonies2.filter(a=>a.rentMAccountId===row.rentMAccountId)[0].taxAmount=  Math.round(row.amount*0.1)
          //     estimateMonies2.filter(a=>a.rentMAccountId===row.rentMAccountId)[0].tax= true
          // }

          //   this.props.change_estimateMonies2(estimateMonies2)
          //   this.props.check_estimates()
          //   this.setState({refresh:!this.state.refresh})
        }
      }]
    } else if (column.key === "deleted") {



      return [{
        icon: <div className="float-right" style={{ textAlign: "center", paddingTop: "5px", paddingRight: "-5px", width: "100px", height: "100px", color: "#ff0000" }}>{row.deleted === 1 ? <i className="fas fa-check" style={{ marginLeft: "20px" }}></i> : ""}</div>,
        callback: () => {
          // row.deleted = row.deleted === 1 ? 0 : 1;
          //         console.log(row.delete)
          let w = this.props.rent_transfer_accounts.map((q: any) => {
            if (q.id === row.id) return { ...q, deleted: row.deleted === 1 ? 0 : 1 };
            return q;
          })
          console.log(w)

          this.props.change_rent_transfer_accounts(w)
          //         // this.setState({ refresh: !this.state.refresh })
          //       }
          //     }]
          //   } else if (column.key === "search") {
          //     if (!row.rent_contract_name1) {
          //       return [{
          //         icon: <Button
          //           color="primary"
          //           variant="contained"
          //           size="small"
          //           type="submit"

          //           style={{ margin: 2, minWidth: 0, width: 50 }}
          //         // onClick={()=>this.add(12)}
          //         >検索
          // </Button>,
          //         callback: () => {
          //           this.props.change_search_id(row.id)

          //           this.props.change_search_detail(row)
          //           // this.props.togglecontract()

          //           this.props.change_search_modal(true)
          //         }
          //       }]
          //     } else {
          //       return [{
          //         icon: <Button
          //           color="primary"
          //           variant="outlined"
          //           size="small"
          //           type="submit"

          //           style={{ margin: 2, minWidth: 0, width: 50 }}
          //         // onClick={()=>this.add(12)}
          //         >編集
          // </Button>,
          //         callback: () => {
          //           this.props.change_search_id(row.id)
          //           this.props.change_search_detail(row)
          //           this.props.change_search_modal(true)
        }
      }]
    } else if (column.key === "rent_customer_name" && row.bk_no) {



      return [{
        icon: <PersonIcon />,
        callback: () => {
          // row.deleted = row.deleted === 1 ? 0 : 1;
          //         console.log(row.delete)
          this.onKyopen(row.bk_no, row.hy_no, row.ky_no)


          // let w = this.props.rent_transfer_accounts.map((q: any) => {
          //   if (q.id === row.id) return { ...q, deleted: row.deleted === 1 ? 0 : 1 };
          //   return q;
          // })
          // console.log(w)

          // this.props.change_rent_transfer_accounts(w)

        }
      }]
    }else if (column.key === "contract_date" ) {



      return [{
        icon: <PersonIcon />,
        callback: () => {
          // row.deleted = row.deleted === 1 ? 0 : 1;
          //         console.log(row.delete)
     
          window.open(`https://crm.homestation.jp/contracts/` + row.rent_contract_id, '_blank', 'noopener')

          // let w = this.props.rent_transfer_accounts.map((q: any) => {
          //   if (q.id === row.id) return { ...q, deleted: row.deleted === 1 ? 0 : 1 };
          //   return q;
          // })
          // console.log(w)

          // this.props.change_rent_transfer_accounts(w)

        }
      }]
    }else if (column.key === "section_name" ) {



      return [{
        icon: <PersonIcon />,
        callback: () => {
          // row.deleted = row.deleted === 1 ? 0 : 1;
          //         console.log(row.delete)
     
          window.open(`https://www.homestation.jp/manage/contract/detail/view?w_id=` + row.workflow_id, '_blank', 'noopener')

          // let w = this.props.rent_transfer_accounts.map((q: any) => {
          //   if (q.id === row.id) return { ...q, deleted: row.deleted === 1 ? 0 : 1 };
          //   return q;
          // })
          // console.log(w)

          // this.props.change_rent_transfer_accounts(w)

        }
      }]
    }



  }





  getRowCount() {
    let count = this.props.rent_transfer_accounts.length;
    if (this.state.refresh && count > 0) {
      count--; // hack for update data-grid
      this.setState({
        refresh: false
      });
    }

    return count;
  }






  render() {

    return (
      <div>

        <ReactDataGrid
          // ref={node => this.grid = node}
          enableCellSelect={false}
          enableRowSelect={false}
          enableCellAutoFocus={false}
          columns={this.state.columns}
          rowGetter={(i: number) => this.props.rent_transfer_accounts[i]}

          getCellActions={this.getCellActions}



          rowsCount={this.getRowCount()}
          headerRenderer={true}
          dragable={true}

          // onCellSelected={false}
          // onColumnResize={(idx, width) =>
          //     console.log(`Column ${idx} has been resized to ${width}`)
          // }
          // emptyRowsView={this.EmptyRowsView}
          onRowClick={this.onRowClick}
          // rowSelection={{
          //   showCheckbox: true,
          //   enableShiftSelect: true,
          //   onRowsSelected: this.onRowsSelected,
          //   onRowsDeselected: this.onRowsDeselected,
          //   selectBy: {
          //     isSelectedKey: 'selected'
          //     // indexes: this.state.selectedIndexes
          //   }
          // }}
          onGridSort={(sortColumn: any, sortDirection: any) => { this.sortRows(this.props.rent_transfer_accounts, sortColumn, sortDirection) }
            //
          }
          //onCellSelected={this.getSelectedCell}
          minHeight={window.innerHeight - 260} />



        <Modal isOpen={this.state.kytoggle} toggle={this.kytoggle} size="xl" fade={false}>

          <ModalHeader toggle={this.kytoggle}>契約情報</ModalHeader>
          {/* <ModalBody> */}
          <KyDetails />
          {/* </ModalBody> */}
          <ModalFooter>
            {/* <button className="btn btn btn-danger" style={{margin:"5px"}} onClick={this.delete_introductions}>削除する</button>*/}
            {/* <button className="btn btn btn-secondary" style={{ margin: "5px" }} onClick={() => this.props.change_search_modal(false)}>キャンセル</button> */}
          </ModalFooter>
        </Modal >
      </div>
    );
  }


}



const mapStateToProps = (state: any) => {
  return {
    // rent_contracts_list: state.rentContractsReducer.rent_contracts_list,
    shops: state.masterReducer.shops,
    rent_transfer_accounts: state.Transfer.rent_transfer_accounts,
  }
}
function mapDispatchToProps(dispatch: any) {
  return {
    change_rent_transfer_accounts(state: any) {
      dispatch(Transfer.change_rent_transfer_accounts(state))
    },
    change_searchky(state: any) {
      dispatch(KyDetail.change_searchky(state))
    },
    // change_search_id(state: any) {
    //   dispatch(Transfer.change_search_id(state))
    // },
    // change_search_modal(state: any) {
    //   dispatch(Transfer.change_search_modal(state))
    // },
    // change_grid_update(state: any) {
    //   dispatch(Transfer.change_grid_update(state))
    // },
    // change_search_detail(state: any) {
    //   dispatch(Transfer.change_search_detail(state))
    // },
    // change_kyousais(state: any) {
    //   dispatch(Transfer.change_kyousais(state))
    // },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountingGridComponent);